import produce from 'immer';

import * as actions from './actions';

export const initialState = {
  error: null,
  accessToken: null,
};

const reducer = (state = initialState, action) => produce(state, (draft) => {
  switch (action.type) {
    case actions.SET_AUTH_SUCCESS:
      draft.accessToken = action.payload.accessToken;
      break;
    case actions.SET_AUTH_FAILURE:
      draft.error = action.payload.error;
      break;
    case actions.INIT_ERROR:
      draft.error = null;
      break;
    default:
  }
});

export default reducer;
